/** Yield after this many directory entries so WebSocket / SIGINT handlers stay responsive. */
export const DISK_WALK_YIELD_EVERY = 64;

/** Legacy layout is `{layout}/{repoRel}/{sessionId}` — do not descend into repo trees or vendor dirs. */
export const LEGACY_WALK_MAX_DEPTH = 12;

export const SKIP_DISK_WALK_DIR_NAMES = new Set([
  'node_modules',
  'bower_components',
  'vendor',
  'Pods',
  'Carthage',
  'DerivedData',
  '.yarn',
  '.pnpm-store',
  'dist',
  'build',
  '.next',
  'coverage',
  '.turbo',
  '.cache',
  'target',
  '__pycache__',
]);

export function shouldSkipDiskWalkEntry(name: string): boolean {
  return name.startsWith('.') || SKIP_DISK_WALK_DIR_NAMES.has(name);
}

export type DiskWalkState = { entries: number };

export type DiskWalkResult = {
  paths: string[];
  entriesVisited: number;
};
